
import { uniqueMountScript } from '../utils';

export async function getPureMaxmindLocation() {
  await uniqueMountScript( 'maxmind-script', '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js');
  return new Promise( (resolve, reject) => {
    window.geoip2.city( resolve, reject);
  });
}

export async function uniqueGetPureMaxmindLocation() {
  if( uniqueGetPureMaxmindLocation.cached) return uniqueGetPureMaxmindLocation.cached;
  else return uniqueGetPureMaxmindLocation.cached = await getPureMaxmindLocation();
}

export async function getLocation() {
  const pureLocation = await uniqueGetPureMaxmindLocation();
  const country = pureLocation.country.iso_code;
  const subdivision_0 = `${country}-${pureLocation.subdivisions[0].iso_code}`;    // Comunidad autonoma
  const subdivision_1 = `${country}-${pureLocation.subdivisions[1].iso_code}`;    // Provincia

  return { country, subdivision_0, subdivision_1, pureLocation };
}

export async function isLocationInList( locationsList) {
  const location = await getLocation();
  return locationsList.indexOf( location.country) > -1 ||
    locationsList.indexOf( location.subdivision_0) > -1 ||
    locationsList.indexOf( location.subdivision_1) > -1;
}
